export default "__VITE_ASSET__0dc3be98__"